import axios from 'axios';
import { API_URL } from '../env';
import { normalize } from './helpers';

const activePokemon = {
    /**
     * `picks`: { energyAttachmentId, benchPosition, defendingMoveId, energyType } for attacks that ask for one.
     * `benchSeen`: how the opponent's bench was arranged when it was picked from (selectOpponentBenchSeen).
     */
    attack: async (gameId, moveId, picks = {}, benchSeen = null) => {
      const response = await axios.patch(`${API_URL}/games/${gameId}/attack`, {
        move_id: moveId,
        energy_attachment_id: picks.energyAttachmentId ?? null,
        bench_position: picks.benchPosition ?? null,
        defending_move_id: picks.defendingMoveId ?? null,
        energy_type: picks.energyType ?? null,
        bench_seen: benchSeen,
      });

      return normalize(response.data);
    }
};

export default activePokemon;
